import { DomainBranding } from '@rygen/rygen-ui/model';

export class ClientSummaryDto {
  id?: number;
  name?: string;
  naturalId?: string;
  branding?: DomainBranding;

  constructor(opts?: Partial<ClientSummaryDto>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
    if (opts?.naturalId != null) {
      this.naturalId = opts.naturalId;
    }
    if (opts?.branding != null) {
      this.branding = new DomainBranding(opts.branding);
    }
  }
}
